import { Grid, Text } from '@approvalmax/ui/src/components';
import { useDispatch } from 'modules/react-redux';
import { loadNewRequestPopup } from 'modules/request';
import { FC, memo, useCallback } from 'react';
import { amplitudeService } from 'services/amplitude';

import { CollapseSection } from '../CollapseSection/CollapseSection';
import { VideoPopup } from '../VideoPopup/VideoPopup';
import { messages } from './RequestCreation.messages';
import { RequestCreationProps } from './RequestCreation.types';

export const RequestCreation: FC<RequestCreationProps> = memo((props) => {
    const { number, collapsed, complete, imgSrc, videoSrc, companyId, profileId } = props;

    const dispatch = useDispatch();

    const showNewRequestPopup = useCallback(() => {
        dispatch(loadNewRequestPopup());

        amplitudeService.sendData('getting started: clicked on create request', {
            user_id: profileId,
            org_id: companyId,
        });
    }, [companyId, dispatch, profileId]);

    const handleVideoOpen = useCallback(() => {
        amplitudeService.sendData('getting started: clicked on video requests', {
            user_id: profileId,
            org_id: companyId,
        });
    }, [companyId, profileId]);

    return (
        <CollapseSection
            collapsed={collapsed}
            complete={complete}
            number={number}
            title={messages.title}
            buttonText={messages.buttonText}
            onButtonClick={showNewRequestPopup}
        >
            <Grid gridTemplateColumns='1fr auto' gap={12}>
                <Text font='body'>{messages.description}</Text>

                <VideoPopup title={messages.title} imgSrc={imgSrc} videoSrc={videoSrc} onOpen={handleVideoOpen} />
            </Grid>
        </CollapseSection>
    );
});

RequestCreation.displayName = 'RequestCreation';
